module.exports = __webpack_public_path__ + "static/media/icon-motorcycle-rt.c4abd590.png";